module.exports = __webpack_public_path__ + "static/media/recruitment_banner.70b3a81f.png";